class loginDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#LoginDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.querySelectorAll('.tab-customer-portal').forEach(evt => evt.addEventListener('click', this.setCurrentTab.bind(evt)));
    this.setUserIconAccessibility();
  }

  setUserIconAccessibility() {
    const userLink = document.querySelector('#user-icon');
    userLink.setAttribute('role', 'button');

    userLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(userLink)
    });

    userLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open();
      }
    });
  }

  open(){
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    document.body.classList.add('overflow-hidden');
  }

  close(){
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  } 

  setCurrentTab(event){
    const loginForm = document.querySelector('.customer__login-drawer.login');
    const registerForm = document.querySelector('.customer__login-drawer.register');
    const selectedTab = event.target;

    document.querySelectorAll('.tab-customer-portal').forEach( tab => tab.classList.remove('current'));
    loginForm.classList.remove('active');
    registerForm.classList.remove('active');

    selectedTab.classList.add('current');

    if(selectedTab.id.includes('login')){
      loginForm.classList.add('active'); 
    } else if (selectedTab.id.includes('register')) {
      registerForm.classList.add('active');
    }

  }

  



}

customElements.define('login-drawer', loginDrawer);